export const HOME = {
  emergentLink: 'home-emergent-link',
  loginButton: 'login-button',
  registerButton: 'register-button',
  heroSection: 'hero-section',
  packagesSection: 'packages-section',
};

export const AUTH = {
  loginForm: 'login-form',
  registerForm: 'register-form',
  emailInput: 'email-input',
  passwordInput: 'password-input',
  submitButton: 'submit-button',
};

export const DASHBOARD = {
  statsWidget: 'stats-widget',
  ordersTable: 'orders-table',
  sidebar: 'dashboard-sidebar',
};

export const PACKAGES = {
  packageCard: 'package-card',
  packageDetail: 'package-detail',
  bookButton: 'book-button',
};

export const CART = {
  cartItems: 'cart-items',
  checkoutButton: 'checkout-button',
  removeButton: 'remove-button',
};
